import React from 'react'
import { connect } from 'react-redux'
import Header from "../default/header/header";
import Footer from "../default/footer/footer";
import "../commonLayout.css";
import "./unauth.css";
import "../default/default.css";

const Unauth = (props) => {
    return (
        <>
            <div className="defaultLayout">
                <Header />
            </div>
            <div className="commonLayout">
                {props.children}
            </div>
            <div className="defaultLayout">
                <Footer />
            </div>
        </>
    );
}

// export default Unauth
const mapStateToProps = state => ({
    shared: state.shared
})
export default connect(mapStateToProps, {})(Unauth)
